import type { BackendRouteDefinition } from '../types';

// Phase 3 mutation workflows and Phase 4 long-running endpoints are kept out
// of this shared object so each future transport migration can update its own
// route module without touching shared.ts.
export const sharedRoutes = {
  getApiVersion: {
    transport: 'api',
    method: 'GET',
    path: '/version',
  },
  // The six ARAG read + session callables moved out of shared.ts in S3-WB1
  // (PRA-789), and `acceptAragCase` followed in S3-WB2 (PRA-790); each lives
  // in its own module under `apps/firms/src/backend/routes/` so the eventual
  // S9-WB2 retirement sweep can edit a single file at a time.
  //
  // The three firms employee-management callables (`sendEmployeeInvite`,
  // `sendEmployeePasswordResetLink`, `updateEmployee`) moved out of
  // shared.ts in S6-WB2 (PRA-795) for the same reason.
  // `getAllMerchantInfoForFirm`, `getPaymentPagesAuthenticated`, and
  // `getPaymentInstrumentsForFirmAsBuyer` moved out of shared.ts in S5-WB1
  // (PRA-792); each lives in its own module under
  // `apps/firms/src/backend/routes/` so the eventual S9-WB2 retirement
  // sweep can edit a single file at a time.
  //
  // The two Typesense callables (`getScopedTypesenseKey` and
  // `performInitialTypesenseSync`) moved out of shared.ts in S7-WB3
  // (PRA-800) when they flipped to the api transport. Each lives in
  // `apps/firms/src/backend/routes/typesense.ts` so the eventual S9-WB2
  // retirement sweep can edit a single file.
  //
  // The three telemetry / template / daily-summary callables
  // (`logFrontendEvent`, `loadAndFillTextTemplateSecondGen`,
  // `dailySummarySecondGen`) moved out of shared.ts in S8-WB1 (PRA-802)
  // when they flipped to the api transport. Each lives in its own module
  // under `apps/firms/src/backend/routes/` so the S9-WB2 retirement
  // sweep can edit a single file at a time.
  //
  // Three stale `transport: 'callable'` entries (`addOrUpdateWorldpaySecrets`,
  // `fakeFinixWebhook`, `autoSendConfirmationEmail`) were deleted in PRA-825
  // (the Phase 6 PRE-1 prerequisite). The Cloud Function backends had already
  // been retired and only the frontend route entries / wrappers remained.
  //
  // `generateMatterFollowUpEmailDraft` was the last live `transport: 'callable'`
  // entry. PRA-825 migrated it to `api-longrun-node` and lifted the frontend
  // route definition into its own module
  // (`apps/firms/src/backend/routes/generateMatterFollowUpEmailDraft.ts`) so
  // every entry in `shared.ts` is now `transport: 'api'`.
  //
  // Engagement-letter callables (`getEngagementLetterSecondGen`,
  // `recordSignaturePortalView`, `saveEngagementLetterSignatureSecondGen`)
  // moved out of shared.ts in S4-WB1 (PRA-791) and now live in their own
  // route-definition modules under `apps/firms/src/backend/routes/` so the
  // S9-WB2 callable-retirement sweep can edit one file at a time.
} as const satisfies Record<string, BackendRouteDefinition>;
